import EngagementMethodType from '../Models/EngagementMethodType';
import DataGridRequest from './DataGridRequest';
export class EngagementMethodsRequest extends DataGridRequest<EngagementMethodType> {
    Url = '/api/v1/settings/engagement_methods';
}
